import { Container, Graphics, Rectangle } from 'pixi.js';
import { COLORS, DESIGN_W, SCRIM } from '../app/theme';
import { viewport } from '../app/viewport';
import { Panel, makeText, sceneBackground, backButton } from './widgets';
import { sceneTitle, bottomBar, listHeight, LIST_PAGE } from '../scenes/common';
import { ScrollList } from './ScrollList';

/**
 * A full-screen list sub-page (Unity-style): wood backdrop, a gold title at the top, a scrollable list,
 * and a bottom «بازگشت» button. Used for the agent referred-users list. Add it to the scene on top of
 * everything; `onBack` removes it. An opaque backdrop + a tap-catcher block input to the page behind.
 */
export class ListModal extends Container {
  constructor(title: string, rows: Container[], onBack: () => void) {
    super();
    this.addChild(sceneBackground());
    const catcher = new Graphics().rect(0, 0, DESIGN_W, viewport.h).fill({ color: COLORS.scrim, alpha: SCRIM.list });
    catcher.eventMode = 'static';
    catcher.hitArea = new Rectangle(0, 0, DESIGN_W, viewport.h);
    this.addChild(catcher);

    this.addChild(sceneTitle(title, 44));

    const list = new ScrollList(LIST_PAGE.width, listHeight(150, 110));
    list.position.set(LIST_PAGE.left, 150);
    list.setItems(rows.length ? rows : [ListModal.emptyRow()]);
    this.addChild(list);

    this.addChild(bottomBar([backButton(onBack)])[0]);
  }

  private static emptyRow(): Container {
    const w = DESIGN_W - 48 - 30;
    const c = new Container();
    c.addChild(new Panel(w, 60, { fill: COLORS.panelSoft }));
    const t = makeText('موردی برای نمایش وجود ندارد', { size: 20, fill: COLORS.textDim, align: 'center' });
    t.anchor.set(0.5);
    t.position.set(w / 2, 30);
    c.addChild(t);
    return c;
  }
}
